var _rect, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCvPreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 209,
    viewBox: "0 0 157 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156.21,
    height: 208.026,
    rx: 3,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 155.21,
    height: 207.026,
    rx: 2.5,
    stroke: "#327585",
    strokeOpacity: 0.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14.5,
    x2: 66.3824,
    y2: 14.5,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 22.1068,
    x2: 66.3824,
    y2: 22.1068,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 29.7136,
    x2: 66.3824,
    y2: 29.7136,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 44.9274,
    x2: 145,
    y2: 44.9274,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 52.5342,
    x2: 145,
    y2: 52.5342,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 60.141,
    x2: 145,
    y2: 60.141,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 67.7478,
    x2: 145,
    y2: 67.7478,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 75.3547,
    x2: 145,
    y2: 75.3547,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 96.6538,
    x2: 145,
    y2: 96.6538,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 104.261,
    x2: 145,
    y2: 104.261,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 111.868,
    x2: 145,
    y2: 111.868,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 119.474,
    x2: 145,
    y2: 119.474,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 117.206,
    y1: 192.5,
    x2: 145,
    y2: 192.5,
    stroke: "#327585",
    strokeOpacity: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 192.5,
    x2: 37.7941,
    y2: 192.5,
    stroke: "#327585",
    strokeOpacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvPreview);
export default __webpack_public_path__ + "static/media/cv-preview.876b62cfabbdf2bc0f3ef1152e860486.svg";
export { ForwardRef as ReactComponent };